import { parsePhoneNumber } from 'awesome-phonenumber'

export const validatePhone = (value: number, countryCode: string) => {
  if (!value || !countryCode) return false

  const valueFormatted = value.toString()

  const phone = parsePhoneNumber(valueFormatted, { regionCode: countryCode })

  return phone.valid
}
